<template>
  <div class="tag_container card-container">
    <el-card>
      <div slot="header" class="clearfix" style="text-align: center">
        <span style="font-weight: bold;font-size: 20px;">用户注册</span>
      </div>
      <div style="width: 500px;margin: 0 auto">
        <el-form ref="registerForm" :model="registerForm" :rules="rules" label-width="80px" :hide-required-asterisk="true">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="registerForm.username" placeholder="请输入用户名" clearable></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="registerForm.password" placeholder="请输入密码" show-password clearable></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="password2">
            <el-input v-model="registerForm.password2" placeholder="请再次输入密码" show-password clearable></el-input>
          </el-form-item>
          <el-form-item label="邀请码" prop="registerCode">
            <el-input v-model="registerForm.registerCode" placeholder="请输入邀请码" clearable></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="valicode">

            <el-row :gutter="20" type="flex" justify="space-between" style="height: 40px">
              <el-col :span="13">
                <el-input v-model="registerForm.valicode" placeholder="请输入验证码" clearable></el-input>
              </el-col>
              <el-col :span=7>
                <div>
                  <el-image  style="width: 108px; height: 40px" :src="registerImage"></el-image>
                </div>
              </el-col>

              <el-col :span="4">
                <div align="right">
                  <el-link :underline="false" type="primary" @click="changeCode">看不清</el-link>
                </div>
              </el-col>
            </el-row>

          </el-form-item>

          <el-form-item>
            <el-checkbox v-model="checked"></el-checkbox>
              <span style="font-weight: bold;margin-left: 5px">
                  我已阅读并同意
              </span>

            <a href="javascript:void(0)" rel="external nofollow" @click="openAgreement">
              <span style="font-weight: bold">
                《注册协议》
              </span>
            </a>

          </el-form-item>

          <el-form-item>
            <el-button class="button-container" type="primary" @click="onSubmit('registerForm')" :disabled="!checked">提交</el-button>
            <el-button class="button-container" @click="resetForm('registerForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-dialog
      :visible.sync="dialogRegisterVisible"
      title="温馨提示"
      width="30%" center>
      <span style="text-align: center;display:block;">您已注册成功，是否要登录？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goLogin">确定</el-button>
        <el-button @click="goHome">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="用户注册协议" :visible.sync="dialogAgreementVisible">

      <el-scrollbar >
        <div style="height: 400px;line-height: 1.5;letter-spacing: 1.2px;margin: 0 20px">
          <div class="div-detail">
            在您成为****门户网站（简称“****网”）实名注册用户（简称“注册用户”）之前，请确认您已充分阅读、理解并接受本协议的全部内容，同意遵循本协议的所有约定。如您不同意本服务协议及或随时对其的补充和修改，您可以主动停止使用****网提供的服务；您一旦使用，即视为您已了解并完全同意本服务协议各项内容，包括****网对本协议随时所做的任何补充和修改。
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              1.【协议适用主体范围】
            </span>
            <span class="div-info">
              ****网的运营管理权归****所有。本协议是您和****网运行中心，明确双方通过****网查询、办理考务服务事项、网上留言等过程中的权利义务所订立的协议。订立本协议的用户，应当是具备完全民事权利能力和完全民事行为能力的自然人。
            </span>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              2.【服务内容】
            </span>
            <span class="div-info">
              注册用户在****网能够进行查询考务服务信息事项等，可在专属用户空间使用我的查询准考证、留言、查询成绩等个性化服务，储存信息资料，并自行维护用户信息。
            </span>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              3.【注册信息提供及账号管理】
            </span>
            <span class="div-info">
              注册用户的账号所有权归属****网，用户在注册账号时，应当按注册页面引导提供真实、准确、最新和完整的个人资料，使用本人手机号码、身份证号等个人信息进行实名验证。用户阅读并同意本协议且完成全部注册程序后，即可获得****网账号并成为*****网用户，请按以下规则管理账号：
            </span>
            <div class="div-detail">
              （1）不得以虚假信息或其他违法和不良信息进行注册。
            </div>
            <div class="div-detail">
              （2）不得将账号、密码转让或出借予他人使用。
            </div>
            <div class="div-detail">
              （3）若违反相关法律法规和本协议各项规定，****网有权对该用户账号单方采取暂停使用、注销登记等措施。
            </div>
            <div class="div-detail">
              （4）若服务被终止或取消，****网可以从服务器上永久地删除该用户的数据；服务终止或取消后，****网没有义务向用户返还或恢复任何数据。
            </div>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              4.【用户承诺和授权】
            </span>
            <span class="div-info">
              注册用户在使用****网账号时承诺并确认：
            </span>
            <div class="div-detail">
              （1）遵守中国法律和法规，遵守所有与网络服务有关的网络协议、规定和程序。
            </div>
            <div class="div-detail">
              （2）不得利用****网进行任何可能对互联网的正常运转造成不利影响的行为。
            </div>
            <div class="div-detail">
              （3）不得利用****网进行任何不利于****网的行为。
            </div>
            <div class="div-detail">
              （4）用户应当对其所提供内容的真实性、合法性负责，不得出现违法和不良信息。
            </div>
            <div class="div-detail">
              （5）用户同意接收****网推送的信息。
            </div>
            <div class="div-detail">
              （6）用户上传到****网的除个人信息以外的文字、图片和音视频等内容，****网具有免费使用权。
            </div>
            <div class="div-detail">
              （7）****网提供的网络服务内容可能包括：文字、软件、声音、图片、视频、图表等。所有这些内容受版权、商标和其他财产所有权法律的保护，用户只有在获得****网或其他相关权利人的授权之后才能使用这些内容。
            </div>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              5.【隐私保护】
            </span>
            <span class="div-info">
              ****网依法保护个人隐私，不得违法违规向第三方提供用户注册资料，但下列情况除外：
            </span>
            <div class="div-detail">
              （1）事先获得用户的明确授权；
            </div>
            <div class="div-detail">
              （2）根据有关的法律法规要求；
            </div>
            <div class="div-detail">
              （3）按照相关政府主管部门的要求；
            </div>
            <div class="div-detail">
              （4）为维护社会公众的利益；
            </div>
            <div class="div-detail">
              （5）为维护****网的合法权益；
            </div>
            <div class="div-detail">
              （6）符合其它相关要求。
            </div>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              6.【禁止条款】
            </span>
            <span class="div-info">
              注册用户有违反法律法规行为的，****网有权终止为用户提供服务，并保留追责的权利。
            </span>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              7.【注意事项】
            </span>
            <span class="div-info">
              ****网将加强网络安全管理和风险防控，因技术原因和网络中断等因素，可能会造成注册用户的实时操作无效或暂停，请注意备份相关资料。
            </span>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              8.【免责声明】
            </span>
            <span class="div-info">
              注册用户同意发生下列情形时，****网将不承担任何责任，包括但不限于：
            </span>
            <div class="div-detail">
              （1）因****网不定期对提供网络服务的平台或相关的设备进行检修或者维护而导致的服务中断。
            </div>
            <div class="div-detail">
              （2）因不可抗力、黑客攻击、病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵等原因而导致的用户信息泄漏、服务中断及其他损失。
            </div>
            <div class="div-detail">
              （3）因注册用户所发布的言论或内容涉嫌构成违法和不良信息，****网有权不经通知单方面采取删除、屏蔽或断开连接等措施。
            </div>
            <div class="div-detail">
              （4）注册用户使用****网服务过程中导致****网或任何其他第三方产生损失的，用户应当承担全部责任。
            </div>
            <div class="div-detail">
              （5）注册用户使用****网网络服务而产生的任何其他后果。
            </div>
          </div>
          <div class="div-info-container">
            <span class="div-nano-title">
              9.【其他规定】
            </span>
            <div class="div-detail">
              （1）用户知悉并授权****网在必需的情况下使用或与关联单位同步用户信息，以为用户提供征信及其他相关服务。
            </div>
            <div class="div-detail">
              （2）本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
            </div>
            <div class="div-detail">
              （3）如双方就本协议内容或执行发生任何争议，双方应协商解决；协商不成时，应向****网运营方所在地人民法院提起诉讼解决。
            </div>
            <div class="div-detail">
              （4）****网保留对本协议的最终解释权。
            </div>
          </div>
        </div>
      </el-scrollbar>

      <div style="text-align: center;margin: 15px 0">
        <el-button type="primary" @click="agreeClick" style="width: 140px;height: 50px;font-size: 18px">
          同意协议
        </el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import bus from '../../../../js/bus'
import Common from '../../../../js/Common'
import {captcha, userRegister} from '../../../../request/api'
// import {UserInfoValid, RegistoryUser} from '../../../../request/api'

export default {
  name: 'Register',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不可为空'))
      } else {
        if (this.registerForm.password2 !== '') {
          this.$refs.registerForm.validateField('password2')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('确认密码不可为空'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      checked: false,
      dialogAgreementVisible: false,
      dialogRegisterVisible: false,
      registerCodeID: '',
      registerImage: '',
      registerForm: {
        username: '',
        password: '',
        password2: '',
        registerCode: '',
        valicode: ''
      },
      rules: {
        username: [
          {required: true, message: '验证码不可为空', trigger: 'blur'}
        ],

        password: [
          {validator: validatePass, trigger: 'blur'}
        ],
        password2: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        registerCode: [
          {required: true, message: '验证码不可为空', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '验证码不可为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {

    init () {
      captcha().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.registerCodeID = res.data.captchaId
          this.registerImage = Common.getValiCodeImage(res.data.imageUrl)
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        console.log(error)
        this.$message.error(error)
      })
    },

    onSubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var parma = {
            'username': this.registerForm.username,
            'password': this.registerForm.password,
            'valicode': this.registerForm.valicode,
            'loginCodeID': this.registerCodeID,
            'registerCode': this.registerForm.registerCode
          }

          userRegister(parma).then(res => {
            console.log(res)

            if (res.code === '90') {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.dialogRegisterVisible = true
              this.resetForm('registerForm')
            } else {
              this.init()
              this.resetForm('registerForm')
              this.$message.error(res.msg)
            }
          }).catch((error) => {
            // error
            console.log(error)
          })
        } else {
          return false
        }
      })
    },
    resetForm (form) {
      this.$refs[form].resetFields()
    },
    changeCode () {
      this.registerImage = Common.reloadValiCodeImage(this.registerCodeID)
      console.log(this.registerCodeID)
    },
    goLogin () {
      this.dialogRegisterVisible = false
      bus.$emit('goLogin')
    },
    goHome () {
      this.dialogRegisterVisible = false
      this.$router.push('/')
    },
    openAgreement () {
      this.dialogAgreementVisible = true
    },
    agreeClick () {
      this.dialogAgreementVisible = false
      this.checked = true
    }
  },
  created () {
    this.init()
  },
  mounted () {
    // this.init()
  }
}
</script>

<style scoped>
.card-container{
  padding-top: 10px;
}
.button-container{
  width: 130px;
  margin: 0 30px;
}
.div-info-container{
  margin: 15px 0;
}

.div-nano-title{
  font-weight: bold;
  font-size: 16px;
}

.div-info{
  font-size: 16px;
}

.div-detail{
  font-size: 16px;
  text-indent: 2em;
}

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/register/Register.vue